<aside class="sidebar">
    <div class="sidebar-top">
        <img class="sidebar-logo" src="/assets/img/logo-black.svg" alt="logo">
    </div>

    <nav class="sidebar-navigation" *ngIf="authenticated$ | async; let authenticated">
        <ul>
            <li>
                <a routerLinkActive="active" routerLink="/performances">
                    <i class="i i-performance"></i>
                    {{ 'shared.sidebar.performances' | translate }}
                </a>
            </li>
            <li>
                <a routerLinkActive="active" routerLink="/offers" *ngIf="hasScope('OFFER')">
                    <i class="i i-offers"></i>
                    {{ 'shared.sidebar.offers' | translate }}
                </a>
            </li>
            <li>
                <a routerLinkActive="active" routerLink="/coupons" *ngIf="hasScope('OFFER') && authenticated?.program?.configuration?.has_coupon">
                    <i class="i i-qr-code"></i>
                    {{ 'shared.sidebar.coupons' | translate }}
                </a>
            </li>
            <li>
                <a routerLinkActive="active" routerLink="/campaigns"  *ngIf="hasScope('STRATEGY')">
                    <i class="i i-merchant"></i>
                    {{ 'shared.sidebar.campaigns' | translate }}
                    <div class="scope-counter" *ngIf="activeCampaigns">{{ openIssues > 99 ? '99+' : activeCampaigns }}</div>
                </a>
            </li>
            <li>
                <a routerLinkActive="active" routerLink="/consumers" *ngIf="hasScope('CONSUMER')">
                    <i class="i i-customer"></i>
                    {{ 'shared.sidebar.consumers' | translate }}
                </a>
            </li>
            <li>
                <a routerLinkActive="active" routerLink="/reports/reward" *ngIf="hasScope('REWARD')">
                    <i class="i i-report"></i>
                    {{ 'shared.sidebar.reporting' | translate }}
                </a>
            </li>
            <li>
                <a routerLinkActive="active" routerLink="/gifts" *ngIf="hasScope('GIFT')">
                    <i class="i i-wallet"></i>
                    {{ 'shared.sidebar.gifts' | translate }}
                </a>
            </li>
            <li>
                <a routerLinkActive="active" routerLink="/invoices" *ngIf="hasScope('INVOICE')">
                    <i class="i i-invoices"></i>
                    {{ 'shared.sidebar.invoices' | translate }}
                </a>
            </li>
            <!-- <li>
                <a routerLinkActive="active" routerLink="/consumer-events" *ngIf="hasScope('CONSUMER_EVENT')">
                    <i class="i i-split"></i>
                    {{ 'shared.sidebar.consumer-events' | translate }}
                </a>
            </li> -->
            <li>
                <a routerLinkActive="active" routerLink="/account">
                    <i class="i i-settings"></i>
                    {{ 'shared.sidebar.account' | translate }}
                </a>
            </li>
        </ul>
    </nav>

    <div class="{{SSOEnabled ? 'sidebar-bottom-langs' : 'sidebar-langs'}}">
        <app-lang-switcher></app-lang-switcher>

        <div>
            <a href="https://docs.paylead.fr/program/shift/overview" target="_blank" rel="noopener noreferrer">
                {{ 'shared.sidebar.documentation' | translate }}
            </a>
            <a href="https://paylead-help.freshdesk.com/support/home" target="_blank" rel="noopener noreferrer">
                {{ 'shared.sidebar.support' | translate }}
            </a>
            <a (click)="onOpenHelp()">
                {{ 'shared.sidebar.ticket' | translate }}
            </a>
        </div>
    </div>

    <nav class="sidebar-bottom" *ngIf="!SSOEnabled">
        <a (click)="logout()">{{ 'shared.sidebar.logout' | translate }}</a>
    </nav>
</aside>
